import { Skill } from "./Favorite";

export type OrgWorker = {
  workerId: number;
  firstName: string;
  lastName: string;
  email: string | null;
  phoneNumber: string;
  personalIdentityNumber: string;
  externalId: string;
  employmentInfo: EmploymentInfo;
  workGroups: Workgroup[];
  isRegistered: boolean;
  isActive: boolean;
};

export type EmploymentInfo = {
  current: Employment;
  next: Employment;
  previous: Employment;
  endDate: string;
  startDate: string;
};

export type Workgroup = {
  id: number;
  name: string;
  type: string;
};

export type StampClockTeam = {
  workGroupId: number;
  workGroupName: string;
};

export type Employment = {
  employeeCategory: string;
  employeeNumber: number;
  employmentType: string;
  salary: number;
  salaryType: string;
  workPercentage: number;
  startDate: string;
  endDate: string;
  taxTable: number;
  paymentType: string;
  role: string;
};

export type Team = {
  id: number;
  name: string;
  companyUnitId: number;
  workers: OrgWorker[];
};

export type Unit = {
  id: number;
  name: string;
  companyEntityId: number;
  workGroups: Team[];
};

export type Entity = {
  id: number;
  name: string;
  companyId: number;
  units: Unit[];
};

export type Structure = {
  entities: Entity[];
};

export type WorkerFormData = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  personalIdentityNumber: string;
  employmentType: string | undefined;
  workGroupIds: number[];
  salaryType: string | undefined;
  salary: number;
  startDate: string | undefined;
  endDate: string | null;
  workPercentage: number | undefined;
  taxTable: number;
  paymentType: string;
  role: string;
  employeeCategory: string;
  employeeNumber: number | undefined;
};

export type Stat = {
  stat: string;
  value: number;
};

export type Document = {
  fileName: string;
  fileSize: number;
  downloadUrl: string;
};

export type WorkerProfileData = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  personalIdentityNumber: string;
  employmentType: string | undefined; 
  workGroupIds: any[];
  salaryType: string | undefined;
  salary: number | undefined;
  startDate: string | undefined;
  endDate: string | null;
  description: string | undefined;
  skills: Skill[];
  stats: Stat[];
  documents: Document[];
  workPercentage: number;
  taxTable: number;
  paymentType: string;
  role: string;
  employeeCategory: string;
  employeeNumber: number | undefined;
};

export const EMPLOYMENT_OPTIONS = [
  { value: "Employee", label: "OrganizationalStructure.Employee" },
  {
    value: "TemporaryWorker",
    label: "OrganizationalStructure.TemporaryWorker",
  },
  {
    value: "ExclusiveTemporaryWorker",
    label: "OrganizationalStructure.ExclusiveTemporaryWorker",
  },
  {
    value: "ProjectEmployee",
    label: "OrganizationalStructure.ProjectEmployee",
  },
  {
    value: "SimflexityEmployee",
    label: "OrganizationalStructure.SimflexityEmployee",
  },
  { value: "Consultant", label: "OrganizationalStructure.Consultant" },
  { value: "Trainee", label: "OrganizationalStructure.Trainee" },
];

export const SALARY_OPTIONS = [
  { value: "Monthly", label: "OrganizationalStructure.Month" },
  { value: "Hourly", label: "OrganizationalStructure.Hour" },
];

export const PAYMENT_TYPE_OPTIONS = [
  { value: "SimflexityPay", label: "ProfileCompany.SimflexityPay" },
  { value: "None", label: "ProfileCompany.OwnSalaryManagement" },
];

export const EMPLOYEE_CATEGORY_OPTIONS = [
  { value: "BlueCollar", label: "OrganizationalStructure.BlueCollar" },
  {
    value: "WhiteCollar",
    label: "OrganizationalStructure.WhiteCollar",
  },
  {
    value: "Owner",
    label: "OrganizationalStructure.Owner",
  },
];
